export const lightTheme = {
	background: '#eceeee',
	secondary: '#f1f4dc',
	textColor: '#000',
	boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
	dropDownShadow: '5px 5px 8px #e0e3cd, -5px -5px 8px #ffffeb'
};

export const darkTheme = {
	background: '#1b1b2f',
	secondary: '#1f4068',
	textColor: '#fff',
	boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
	dropDownShadow: '4px 4px 4px #1b3759, -4px -4px 4px #234977'
};
